import type { IcIcon } from "./types";

export const IcLoading: IcIcon = (properties) => (
  <svg
    fill="currentColor"
    height="10"
    id="loading-circles"
    viewBox="0 0 42 5"
    width="42"
    xmlns="http://www.w3.org/2000/svg"
    {...properties}
  >
    <circle cx="3" cy="2.5" id="circle1" r="2.5" stroke="currentColor">
      <animate
        attributeName="opacity"
        begin="0"
        dur="1s"
        repeatCount="indefinite"
        values="0;1;0"
      />
    </circle>
    <circle cx="21" cy="2.5" id="circle2" r="2.5" stroke="currentColor">
      <animate
        attributeName="opacity"
        begin=".2"
        dur="1s"
        repeatCount="indefinite"
        values="0;1;0"
      />
    </circle>
    <circle cx="39" cy="2.5" id="circle3" r="2.5" stroke="currentColor">
      <animate
        attributeName="opacity"
        begin=".4"
        dur="1s"
        repeatCount="indefinite"
        values="0;1;0"
      />
    </circle>
  </svg>
);
